import { useEffect, useState } from "react";

export function ScreenTrigger(breakpoint) {
  const [isMdOrLess, setIsMdOrLess] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMdOrLess(window.innerWidth < breakpoint);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMdOrLess;
}
